import { ServerService } from 'app/model/services/api-services/server.service';
import { ModalLoginMessage, ModalLoginHandler } from './../../../types/modal-login-message';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalConfirmMsg } from 'app/types/modalconfirmmsg';
import { ModalProgMsg } from 'app/types/modalprogmsg';
import { ModalNotice } from 'app/types/modalnotice';
// import * as $ from 'jquery';
import { ModalFileRequestMessage } from 'app/types/modalfilerequestmessage';
import { ModaLRemoteCtrlMessage } from 'app/types/modall-remote-ctrl-message';
import { ModalFileDownloadRequestMessage } from 'app/types/modal-file-download-request';
import { Dict } from 'app/types/decorable';
import { DictHandler, SimpleHandler } from 'app/types/handlers';

@Injectable({
  providedIn: 'root'
})
export class ModalMessagerService {
  public remoteCtrl$ = new Subject<ModaLRemoteCtrlMessage>();
  public notify$ = new Subject<ModalNotice>();
  public progress$ = new Subject<ModalProgMsg>();
  public confirm$ = new Subject<ModalConfirmMsg>();
  public cancellation$ = new Subject<Dict>();
  public importRequest$ = new Subject<ModalFileRequestMessage>();
  public exportRequest$ = new Subject<ModalFileRequestMessage>();
  public downloadRequest$ = new Subject<ModalFileDownloadRequestMessage>();
  public login$ = new Subject<ModalLoginMessage>();
  constructor() { }

  Notify(
    displayMessage: string,
    warn: boolean = false,
    optTitle: string = 'Notice'): void {
    const message: ModalNotice = {
      type: 'notice',
      message: displayMessage,
      title: optTitle,
      asWarning: warn
    };
    this.notify$.next(message);
  }

  Progress(
    displayMessage: string,
    isCancelable: boolean,
    optPercent: number = NaN,
    optTitle: string = 'Progress Notice',
    optCancelHandler: DictHandler | null = null) {
    const message: ModalProgMsg = {
      type: 'progress',
      message: displayMessage,
      title: optTitle,
      progress: optPercent,
      cancelable: isCancelable,
      cancelHandler: optCancelHandler
    };
    this.progress$.next(message);
  }
  CancelProgress(progTitle: string): void {
    this.cancellation$.next({ title: progTitle });
  }
  Confirm(
    displayMessage: string,
    optOkHandler: SimpleHandler | DictHandler | null,
    optCancelHandler: SimpleHandler | DictHandler | null,
    optTitle: string = 'Confirmation Notice') {
    const message: ModalConfirmMsg = {
      type: 'confirm',
      message: displayMessage,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.confirm$.next(message);
  }
  RequestImport(
    readParams: {
      acceptedExtentions: Array<string>
      readType?: 'string' | 'buffer' | 'dataURL' | 'text';
      encoding?: string;
    },
    displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Import File ...'
  ) {
    if (!optOkHandler) {
      optOkHandler = () => { };
    }

    if (!optCancelHandler) {
      optCancelHandler = () => { };
    }
    const message: ModalFileRequestMessage = {
      type: 'request-import',
      message: displayMessage,
      title: optTitle,
      acceptedExts: readParams.acceptedExtentions,
      readType: !!readParams.readType ? readParams.readType : null,
      encoding: !!readParams.encoding ? readParams.encoding : null,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.importRequest$.next(message);
  }
  RequestExport(
    writeParams: {
      extension: string;
      mimeType: string;
      contents: any;
      defaultFileName?: string;
    },
    displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Import/Export File ...'
  ) {
    if (!optOkHandler) {
      optOkHandler = () => { };
    }

    if (!optCancelHandler) {
      optCancelHandler = () => { };
    }
    const message: ModalFileRequestMessage = {
      type: 'request-export',
      message: displayMessage,
      acceptedExts: [writeParams.extension],
      defaultFileName: (writeParams.defaultFileName),
      encoding: writeParams.mimeType,
      contents: writeParams.contents,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.exportRequest$.next(message);
  }
  RequestDownload(
    writeParams: {
      extension: string;
      mimeType: string;
      defaultFileName?: string;
    },
    serverURL: string,
    wapiParams: any,
    displayMessage: string,
    optOkHandler?: SimpleHandler | DictHandler,
    optCancelHandler?: SimpleHandler | DictHandler,
    optTitle: string = 'Download File ...'
  ) {
    if (!optOkHandler) {
      optOkHandler = () => { };
    }

    if (!optCancelHandler) {
      optCancelHandler = () => { };
    }
    const message: ModalFileDownloadRequestMessage = {
      type: 'request-download',
      message: displayMessage,
      acceptedExts: [writeParams.extension],
      defaultFileName: (writeParams.defaultFileName),
      serverURL: (serverURL),
      mimeType: writeParams.mimeType,
      params: wapiParams,
      title: optTitle,
      okHandler: optOkHandler,
      cancelHandler: optCancelHandler,
    };
    this.downloadRequest$.next(message);
  }
  Login(handler: ModalLoginHandler,cancel?:SimpleHandler) {
    const message: ModalLoginMessage = {
      handler: (handler),
      cancelHandler:cancel,
      message: '',
      title: 'Authorization Required',
      type: 'login'
    }
    this.login$.next(message);
  }
  Logout(handler?: SimpleHandler) {
    this.Confirm('Log out of your current session?', () => {
      if(handler) handler();
      this.Notify('You have been logged out.',false,'Come back soon.');
    }, null, 'Are you sure?');
  }
  Ok(title: string) {
    const message: ModaLRemoteCtrlMessage = {
      cmd: 'ok',
      message: '',
      title: (title),
      type: 'remote-ctrl'
    }
    this.remoteCtrl$.next(message);
  }
  Cancel(title: string, reason: string = '') {
    const message: ModaLRemoteCtrlMessage = {
      cmd: 'cancel',
      message: reason,
      title: (title),
      type: 'remote-ctrl'
    }
    this.remoteCtrl$.next(message);
  }
}
